// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a4763467","239":"4039d5a4","453":"2d02b64e","732":"070e1c9e"}[chunkId] + ".chunk.js";
};